import { useState } from "react";
import close1 from "../../../assets/images/model/close.svg";
import filePlus from "../../../assets/images/model/file-plus.svg";
import book from "../../../assets/images/model/book.png";
import bookshelf from "../../../assets/images/model/bookshelf.png";
import PickFromLibrary from "./PickFromLibrary";
import UploadBook from "./UploadBook";
import CreateNewBook from "./CreateNewBook";
import UploadBookLoading from "./UploadBookLoading";
import ConfrimAuthors from "./ConfrimAuthors";
import ChapterSelect from "./ChapterSelect";
import TroubleModel from "./TroubleModel";
import LoadingBook from "./LoadingBook";
import SupportModel from "./SupportModel";
import ThankUploading from "./ThankUploading";
import { upload as uploadTheBook, create } from "../../../Store/api/books";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { associateABook } from "../../../Store/api/classApi";
import { toast } from "react-toastify";

export const SelectOption = ({ selectOption, setSelectOption, mode = "" }) => {
  const dispatch = useDispatch();
  const [bookId, setBookId] = useState("");
  const [linkToFile, setLinkToFile] = useState("");
  const [chosenFile, setChosenFile] = useState(null);
  const [uploadBook, setUploadBook] = useState(false);
  const [loadingBook, setLoadingBook] = useState(false);
  const [thanksModel, setThanksModel] = useState(false);
  const [supportModel, setSupportModel] = useState(false);
  const [troubleModel, setTroubleModel] = useState(false);
  const [selectLibrary, setSelectLibrary] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [createNewBook, setCreateNewBook] = useState(false);
  const [selectChapter, setSelectChapter] = useState(false);
  const [uploadLoadingBook, setUploadLoadingBook] = useState(false);
  const [gotoConfrimAuthor, setGotoConfrimAuthor] = useState(false);
  const [formValues, setFormValues] = useState({
    materialType: "",
    title: "",
    categoryType: "",
    subjects: [],
    originalAuthor: "",
    isImAuthor: false,
    collaborator: "",
  });

  const { classes } = useSelector((state) => state.entities.classes);
  const emptyClass = classes?.filter((clas) => !clas.isBookAssociated)[0];
  const associate = (book) => {
    setBookId(book._id);
    if (mode === "app") {
      dispatch(
        associateABook({
          body: {
            bookId: book._id,
            classId: emptyClass?._id,
          },
          onSuccess: (response) => {
            setThanksModel(true);
            setGotoConfrimAuthor(false);
          },
          onError: (err) => {
            toast.error("Failed to associate a book.");
          },
        })
      );
    } else {
      setThanksModel(true);
      setGotoConfrimAuthor(false);
    }
  };
  const upload = () => {
    setUploadLoading(true);
    if (!chosenFile && linkToFile) {
      dispatch(
        create({
          onSuccess: (res) => {
            associate(res?.data?.data);
            setUploadLoading(false);
          },
          onError: (error) => {
            setUploadLoading(false);
          },
          body: { ...formValues, url: linkToFile },
        })
      );
    } else {
      const formData = new FormData();
      formData.append("pdf", chosenFile);
      for (const key in formValues) {
        if (Object.hasOwnProperty.call(formValues, key)) {
          const value = formValues[key];
          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              formData.append(`${key}[${index}]`, item);
            });
          } else {
            formData.append(key, value);
          }
        }
      }

      dispatch(
        uploadTheBook({
          onSuccess: (res) => {
            associate(res.data?.data);
            setUploadLoading(false);
          },
          onError: (error) => {
            setUploadLoading(false);
          },
          body: formData,
        })
      );
    }
  };

  return (
    <div>
      {selectOption && (
        <div
          className="modal custom_background custom_modal_create"
          id="select_an_option"
          style={{ display: "block" }}
          tabIndex="-1"
          aria-labelledby="select_an_optionLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              {mode !== "app" && (
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    disabled={mode === "app"}
                    onClick={() => setSelectOption(false)}
                  >
                    <img src={close1} alt="close" />
                  </button>
                </div>
              )}
              <div className="modal-body-cre">
                <h4>select an option</h4>
                <p>
                  Start from scratch or upload an existing textbook. Want to
                  modify a book instead? Select a textbook from the Greyled
                  library to edit for your classroom.
                </p>
                <form action="" className="select_an_option">
                  <div className="select_an_option_wrap my-40">
                    <div className="d-flex gap-4">
                      <div
                        className="select_optiob_card cursor"
                        htmlFor="upload_book_folder"
                        onClick={() => {
                          setUploadBook(true);
                        }}
                      >
                        <input
                          type="checkbox"
                          id="upload_book_folder"
                          name="upload_book_folder"
                        />
                        <img
                          src={filePlus}
                          alt="file ico"
                          width={40}
                          height={40}
                        />
                        <p>Upload a book</p>
                      </div>
                      <div
                        className="select_optiob_card cursor"
                        htmlFor="Create_new_book"
                        onClick={() => {
                          if (mode !== "app") {
                            setSelectOption(false);
                          }
                          setCreateNewBook(true);
                        }}
                      >
                        <input
                          type="checkbox"
                          id="Create_new_book"
                          className="Create_new_book"
                        />
                        <img src={book} alt="book ico" width={40} height={40} />
                        <p>Create new book</p>
                      </div>
                      <div
                        className="select_optiob_card cursor"
                        htmlFor="Pick_frm_library"
                        onClick={() => {
                          if (mode !== "app") {
                            setSelectOption(false);
                          }
                          setSelectLibrary(true);
                        }}
                      >
                        <input
                          type="checkbox"
                          id="Pick_frm_library"
                          name="Pick_frm_library"
                        />
                        <img
                          src={bookshelf}
                          alt="bookshelf ico"
                          width={54}
                          height={35}
                        />
                        <p>Pick from library</p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {selectLibrary && (
        <PickFromLibrary
          selectLibrary={selectLibrary}
          setSelectLibrary={setSelectLibrary}
          setSelectOption={setSelectOption}
          mode={mode}
        />
      )}
      {uploadBook && (
        <UploadBook
          setChosenFile={setChosenFile}
          setLinkToFile={setLinkToFile}
          uploadBook={uploadBook}
          setUploadBook={setUploadBook}
          setSelectOption={setSelectOption}
          setUploadLoadingBook={setUploadLoadingBook}
          mode={mode}
        />
      )}
      {createNewBook && (
        <CreateNewBook
          createNewBook={createNewBook}
          setCreateNewBook={setCreateNewBook}
          setSelectOption={setSelectOption}
          mode={mode}
        />
      )}
      {uploadLoadingBook && (
        <UploadBookLoading
          chosenFile={chosenFile}
          linkToFile={linkToFile}
          setUploadBook={setUploadBook}
          setFormValues={setFormValues}
          setUploadLoadingBook={setUploadLoadingBook}
          setSelectOption={setSelectOption}
          formValues={formValues}
          uploadLoading={uploadLoading}
          setGotoConfrimAuthor={setGotoConfrimAuthor}
        />
      )}
      {gotoConfrimAuthor && (
        <ConfrimAuthors
          setGotoConfrimAuthor={setGotoConfrimAuthor}
          upload={upload}
          uploadLoading={uploadLoading}
          setUploadLoadingBook={setUploadLoadingBook}
          selectChapter={selectChapter}
          setThanksModel={setThanksModel}
          formValues={formValues}
        />
        /*  <UnsavedChanges
          setGotoConfrimAuthor={setGotoConfrimAuthor}
          setUploadLoadingBook={setUploadLoadingBook}
          setSelectChapter={setSelectChapter}
          selectChapter={selectChapter}
        /> */
      )}

      {thanksModel && (
        <ThankUploading
          setGotoConfrimAuthor={setGotoConfrimAuthor}
          setUploadLoadingBook={setUploadLoadingBook}
          setSelectChapter={setSelectChapter}
          mode={mode}
          bookId={bookId}
          setThanksModel={setThanksModel}
        />
      )}
      {selectChapter && (
        <ChapterSelect
          setGotoConfrimAuthor={setGotoConfrimAuthor}
          setSelectChapter={setSelectChapter} // Correct prop name
          setUploadLoadingBook={setUploadLoadingBook}
          selectChapter={selectChapter}
          setTroubleModel={setTroubleModel}
          setThanksModel={setThanksModel}
          setLoadingBook={setLoadingBook}
        />
      )}

      {loadingBook && (
        <LoadingBook
          supportModel={supportModel}
          setSupportModel={setSupportModel}
          setLoadingBook={setLoadingBook}
          setTroubleModel={setTroubleModel}
          setThanksModel={setThanksModel}
        />
      )}
      {troubleModel && (
        <TroubleModel
          setSelectChapter={setSelectChapter} // Correct prop name
          setTroubleModel={setTroubleModel}
          setLoadingBook={setLoadingBook}
          setThanksModel={setThanksModel}
          setSupportModel={setSupportModel}
        />
      )}
      {supportModel && (
        <SupportModel
          setTroubleModel={setTroubleModel}
          setSupportModel={setSupportModel}
          setThanksModel={setThanksModel}
        />
      )}
    </div>
  );
};
